import { render, staticRenderFns } from "./EditTwoPhaseMethod.vue?vue&type=template&id=2f01dc5d&scoped=true&"
import script from "./EditTwoPhaseMethod.vue?vue&type=script&lang=js&"
export * from "./EditTwoPhaseMethod.vue?vue&type=script&lang=js&"
import style0 from "./EditTwoPhaseMethod.vue?vue&type=style&index=0&id=2f01dc5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f01dc5d",
  null
  
)

export default component.exports